import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, Eyebrow, ImageReveal } from "@/components/Reveal";

export const STEPS = [
  {
    n: "I",
    t: "Seni Tanıyoruz",
    d: "Kayıt sırasında verdiğin bilgiler ve tercihlerin, sana uygun eşleşme profilini anlamamıza yardımcı olur.",
  },
  {
    n: "II",
    t: "The Five",
    d: "Senin için özenle seçilen beş profili keşfedersin.",
  },
  {
    n: "III",
    t: "Üç Gün",
    s: "Acele etmeden, ama sonsuza kadar da beklemeden.",
    d: "The Five üç gün boyunca açık kalır. Üç günün sonunda yalnızca birbirini seçenler My Date'e geçer.",
  },
  {
    n: "IV",
    t: "My Date",
    s: "Birbirinizi seçtiğinizde, dikkatinizi nereye vermek istediğiniz de netleşir.",
    d: "My Date boyunca ikinize de yeni bir profil önerilmez. Eşleşmeniz devam ettiği sürece karşındaki kişinin de yeni öneriler almadığını bilirsin.",
    d2: "Çünkü birinin kim olduğunu görmek için diğer ihtimalleri bir süre susturmak gerekir.",
  },
  {
    n: "V",
    t: "Geri Bildirim",
    d: "Deneyimini paylaşarak sonraki eşleşmelerinin daha kişisel hale gelmesine katkıda bulunursun.",
  },
];

export default function HowItWorks({ showLink = true }) {
  return (
    <section data-testid="how-it-works-section" className="py-24 sm:py-36 bg-ivory-alt">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 lg:gap-24">
        <div className="lg:sticky lg:top-32 self-start">
          <FadeUp>
            <Eyebrow>Nasıl Çalışır</Eyebrow>
          </FadeUp>
          <FadeUp>
            <h2 data-testid="how-it-works-title" className="mt-7 leading-none text-burgundy">
              <span className="block font-serif font-semibold tracking-[-0.02em] text-5xl sm:text-6xl lg:text-7xl">
                FIVE STAR
              </span>
              <span className="block font-pinyon text-5xl sm:text-6xl lg:text-7xl -mt-4 sm:-mt-5 lg:-mt-7 pl-10 sm:pl-14 lg:pl-20">
                nasıl çalışır?
              </span>
            </h2>
          </FadeUp>
          <FadeUp
            delay={0.2}
            className="mt-6 max-w-sm text-[15px] font-light text-ink-soft/90 leading-relaxed"
          >
            Bir katalog değil, bir süreç. Daha çok deneyim değil, aşkta daha fazlası olsun diye tasarlandı.
          </FadeUp>
          {showLink && (
            <FadeUp delay={0.3} className="mt-8">
              <Link to="/nasil-calisir" data-testid="how-it-works-more-link" className="link-ghost">
                Süreci keşfet
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
            </FadeUp>
          )}
          <FadeUp delay={0.35} className="mt-12 hidden lg:block">
            <ImageReveal
              src="/story/flowers-couple.jpg"
              alt="El ele yürüyen bir çift ve bir demet şakayık"
              className="rounded-[6px] w-72 h-72"
            />
          </FadeUp>
        </div>

        <ol className="relative">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.06}>
              <li
                data-testid={`step-${i + 1}`}
                className="flex gap-6 sm:gap-8 border-t border-burgundy/10 py-9 sm:py-11"
              >
                <span className="font-cinzel text-xl sm:text-2xl text-gold w-10 shrink-0 pt-1">{s.n}</span>
                <div>
                  <h3 className="font-serif text-2xl sm:text-3xl text-ink">{s.t}</h3>
                  {s.s && <p className="mt-2 font-serif italic text-lg sm:text-xl text-burgundy leading-snug max-w-md">{s.s}</p>}
                  <p className="mt-3 max-w-md text-[15px] font-light text-ink-soft/90 leading-relaxed">{s.d}</p>
                  {s.d2 && <p className="mt-3 max-w-md text-[15px] font-light text-ink-soft/90 leading-relaxed">{s.d2}</p>}
                </div>
              </li>
            </FadeUp>
          ))}
          <div className="border-t border-burgundy/10" />
        </ol>
      </div>
    </section>
  );
}
